(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('.page-scroll-up');
    const quickAdd = document.querySelector('.product-quick-add');
    const scrollTrigger = 700;

    if (!button) return;

    const updateButton = () => {
      button.classList.toggle('hidden', window.scrollY < scrollTrigger);

      if (quickAdd) {
        button.style.bottom = `${quickAdd.offsetHeight + 20}px`;
      }
    };

    window.addEventListener('scroll', updateButton, { passive: true });
    button.addEventListener('click', () => window.scroll({ top: 0, behavior: 'smooth' }));
    updateButton();
  })();
  } catch(e) { console.error(e); }
})();

})();
